import styled from 'styled-components'

export const StyledModalHeader = styled.div`
  align-items: flex-start;
  display: flex;
  font-weight: 500;

  justify-content: space-between;
  min-width: min-content;
  padding: 1.5rem;

  > :not(:first-child) {
    margin-left: 1.5rem;
  }
`

export const CloseButton = styled.div`
  align-items: center;
  border-radius: var(--border-radius-sm);
  color: var(--text-disabled);
  cursor: pointer;
  display: flex;

  font-size: 1.5rem;
  font-weight: bolder;

  height: 1.6rem;
  justify-content: center;
  width: 1.6rem;

  &:hover {
    color: var(--theme-primary);
  }
`
